export function sumElementsInArray(array: number[]): number {
	return array.reduce((a, b) => a + b, 0);
}

export function calculateBarChartMax(array: number[][], allArraySum = false): number {
	let max = 0;
	if (array.length === 0) {
		return 0;
	}
	if (allArraySum) {
		max = array.map((items) => Math.max(...items)).reduce((a, b) => a + b, 0);
	} else {
		max = Math.max(...array.flat());
	}
	return Math.ceil(max);
}

export function generateAxisYLabels(min: number, max: number, horizontalLines: number): string[] {
	const step = Math.floor(max / horizontalLines);
	if (step === 0) {
		return [];
	}
	const arr = [];
	for (let i = min; i <= max; i += step) {
		arr.push(i.toString());
	}
	return arr;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sumByObjectProperty(array: any[], property: string): number {
	return array.reduce((accumulator, object) => {
		return accumulator + object[property];
	}, 0);
}
